<template>
  <div class="home">
    <Navbar id="navbar"></Navbar>
    <div id="pagebody" class="container">
      <Assets id="assets" class ="table"></Assets>
      <Liabilities id="liabilities" class ="table"></Liabilities>
      <Income id="income" class ="table"></Income>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//test comment 2
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');
import HelloWorld from '@/components/HelloWorld.vue'

import Navbar from '@/components/Navbar'
import Assets from '@/components/Assets'
import Income from '@/components/Income'
import Liabilities from '@/components/Liabilities'

export default {
  name: 'financials',
  components: {
    HelloWorld,

    Navbar,
    Assets,
    Income,
    Liabilities
  },
  methods:{
    logout: function(){
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  }
}
</script>

<style>
#navbar {
  margin-bottom: 80px;
}


</style>
